// extracted by mini-css-extract-plugin
export var fadeInAnimation = "Card-module--fadeInAnimation--57741";
export var figcaption = "Card-module--figcaption--32089";
export var figure = "Card-module--figure--f9595";
export var img = "Card-module--img--41c8c";
export var link = "Card-module--link--fd39b";